import { QueryClient } from "@tanstack/react-query";
import { getIsUtahParticipant } from "~/participant/utils/getIsUtahParticipant.helpers";
import { PARTICIPANTS_QUERIES } from "~/shared/api/participants/participants.queries";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { notFound } from "~/shared/util/notFound";

export async function gamePlansViewLoader(queryClient: QueryClient) {
  const isUtahParticipant = await getIsUtahParticipant(queryClient);

  if (isUtahParticipant) {
    return notFound();
  }

  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());
  const userId = user?.id;

  if (!userId) {
    return notFound();
  }

  await queryClient.ensureQueryData(PARTICIPANTS_QUERIES.members.listGameplans(userId.toString()));

  return null;
}
